/**
 * Cart dispatch packaging (engine.dispatch_packaging_type).
 * Liquid maps metaobject display names to keys; JS resolves cart state from those keys.
 */

(function () {
  'use strict';

  const TYPE_ENVELOPE = 'envelope';
  const TYPE_TOO_BIG = 'too_big';
  const TYPE_GIFT_BOX = 'gift_box';
  const TYPE_JEWELLERY_DROP_SHIP = 'jewellery_drop_ship';

  /**
   * @param {string[]} uniqueTypes
   * @returns {{ state: string, uniqueTypes: string[], envelopeOnlySpecial: boolean, jewelleryDropShip: boolean }}
   */
  function resolveCartDispatchPackaging(uniqueTypes) {
    const list = Array.isArray(uniqueTypes) ? uniqueTypes.filter(Boolean) : [];
    const jewelleryDropShip = list.includes(TYPE_JEWELLERY_DROP_SHIP);
    const set = new Set(list.filter((t) => t !== TYPE_JEWELLERY_DROP_SHIP));
    const has = (t) => set.has(t);

    if (has(TYPE_TOO_BIG)) {
      return {
        state: 'too_big',
        uniqueTypes: list,
        envelopeOnlySpecial: false,
        jewelleryDropShip,
      };
    }
    if (has(TYPE_GIFT_BOX)) {
      return {
        state: 'gift_box',
        uniqueTypes: list,
        envelopeOnlySpecial: false,
        jewelleryDropShip,
      };
    }
    if (has(TYPE_ENVELOPE) && set.size === 1) {
      return {
        state: 'envelope_only',
        uniqueTypes: list,
        envelopeOnlySpecial: true,
        jewelleryDropShip,
      };
    }
    return {
      state: 'none',
      uniqueTypes: list,
      envelopeOnlySpecial: false,
      jewelleryDropShip,
    };
  }

  /**
   * @param {HTMLElement | null} root
   * @param {{ state: string, jewelleryDropShip?: boolean }} resolved
   */
  function syncPackagingBlockVisibility(root, resolved) {
    if (!root || !resolved) {
      return;
    }
    const giftBlock = root.querySelector('#cart-block-gift-box-selector');
    const altWrap = root.querySelector('[data-cart-dispatch-alternative="true"]');
    const msgTooBig = root.querySelector('#cart-dispatch-msg-too-big');
    const msgEnvelope = root.querySelector('#cart-dispatch-msg-envelope');
    const msgJewellery = root.querySelector('#cart-dispatch-msg-jewellery-drop-ship');
    const hideGift =
      resolved.state === 'too_big' || resolved.state === 'envelope_only';
    if (giftBlock) {
      giftBlock.classList.toggle('hidden', hideGift);
    }
    if (altWrap) {
      altWrap.classList.toggle('hidden', !hideGift);
    }
    if (msgTooBig) {
      msgTooBig.classList.toggle('hidden', resolved.state !== 'too_big');
    }
    if (msgEnvelope) {
      msgEnvelope.classList.toggle('hidden', resolved.state !== 'envelope_only');
    }
    if (msgJewellery) {
      msgJewellery.classList.toggle('hidden', !resolved.jewelleryDropShip);
    }
  }

  /**
   * @param {HTMLElement | null} root
   * @param {{ uniqueTypes?: string[], source?: string } | null} payload
   */
  function applyCartDispatchPackaging(root, payload) {
    if (!root) {
      return;
    }
    const uniqueTypes =
      payload && Array.isArray(payload.uniqueTypes) ? payload.uniqueTypes : [];
    const resolved = resolveCartDispatchPackaging(uniqueTypes);
    root.setAttribute('data-cart-dispatch-packaging', resolved.state);
    root.setAttribute(
      'data-cart-dispatch-envelope-only',
      resolved.envelopeOnlySpecial ? 'true' : 'false'
    );
    syncPackagingBlockVisibility(root, resolved);
    document.dispatchEvent(
      new CustomEvent('cart:dispatch-packaging-resolved', {
        detail: Object.assign({}, resolved, {
          source: (payload && payload.source) || 'unknown',
        }),
      })
    );
  }

  function readConfigFromDom() {
    const el = document.getElementById('cart-dispatch-packaging-config');
    if (!el || !el.textContent) {
      return null;
    }
    try {
      return JSON.parse(el.textContent.trim());
    } catch (e) {
      return null;
    }
  }

  function syncFromDom() {
    const root = document.getElementById('main-cart-items');
    const payload = readConfigFromDom();
    if (!payload) {
      if (root) {
        root.removeAttribute('data-cart-dispatch-packaging');
        root.removeAttribute('data-cart-dispatch-envelope-only');
        syncPackagingBlockVisibility(root, { state: 'none' });
      }
      return;
    }
    applyCartDispatchPackaging(root, payload);
  }

  window.resolveCartDispatchPackaging = resolveCartDispatchPackaging;
  window.applyCartDispatchPackaging = applyCartDispatchPackaging;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFromDom);
  } else {
    syncFromDom();
  }

  document.addEventListener('eurus:cart:items-changed', syncFromDom);
  document.addEventListener('cart:updated', syncFromDom);
})();
